<template>
  <div class="home-sector" :class="{ last: isLast, first: isFirst }">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    isFirst: {
      type: Boolean,
      default: false
    },
    isLast: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
.home-sector {
  margin-top: 15px;
  margin-bottom: 15px;

  &.first {
    margin-top: 0;
  }

  &.last {
    margin-bottom: 0;
  }
}
</style>
